import { render } from "./HeroiconsOutlineCash.vue?vue&type=template&id=6c7f1c38"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCash.vue"]])

export default __exports__